import { gql } from "@apollo/client";

export const ADD_APPOINTMENT = gql`
  mutation addAppointment(
    $professionistId: Int!,
    $patientId: Int!,
    $startAt: DateTime!,
    $invoiceName: String,
    $invoiceSurname: String,
    $invoiceCodFisc: String,
    $address: String,
    $cap: String,
    $city: String,
    $province: String,
    $phone: String,
    $tesseraSanitariaAuth: Boolean,
  ) {
  addAppointment(
    professionist_id: $professionistId,
    patient_id: $patientId,
    start_at: $startAt,
    invoice_name: $invoiceName,
    invoice_surname: $invoiceSurname,
    invoice_cod_fisc: $invoiceCodFisc,
    address: $address,
    cap: $cap,
    city: $city,
    province: $province,
    phone: $phone,
    tessera_sanitaria_auth: $tesseraSanitariaAuth
  )
}
`;
